// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/vipps/v1/vipps.v1.proto (package no.jotta.openapi.vipps.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { GetFlowRequest, GetFlowResponse } from "./vipps.v1_pb.js";
import { MethodKind } from "@bufbuild/protobuf";
import { PingRequest, PingResponse } from "../../ping_pb.js";
/**
 * @generated from service no.jotta.openapi.vipps.v1.VippsService
 */
export const VippsService = {
    typeName: "no.jotta.openapi.vipps.v1.VippsService",
    methods: {
        /**
         * @generated from rpc no.jotta.openapi.vipps.v1.VippsService.GetFlow
         */
        getFlow: {
            name: "GetFlow",
            I: GetFlowRequest,
            O: GetFlowResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Safe noop for testing purposes
         *
         * @generated from rpc no.jotta.openapi.vipps.v1.VippsService.Ping
         */
        ping: {
            name: "Ping",
            I: PingRequest,
            O: PingResponse,
            kind: MethodKind.Unary,
        },
    }
};
